import type { AuthenticatedSession } from './api'

/**
 * Whether the Billing page has a dispute lock switch for this organization: it
 * has one exactly when the billing summary carries the build. An enterprise
 * organization's summary carries none, and a member who is not an
 * administrator is sent none, so "Turn it off under Billing" would send them
 * to a page with nothing to press.
 */
export function disputeLockSwitchAtBilling(session: AuthenticatedSession, orgId: string): boolean {
  return Boolean(session.billing?.find((b) => b.organization_id === orgId)?.composition)
}
